import { Pressable, Text, View } from 'react-native';

import { colors, typography } from '@/theme/tokens';
import { useAuth } from '@/stores/authStore';
import { routesForRole } from '@/navigation/routes';

interface Props {
  current: string;
  onNavigate: (name: string) => void;
}

export function BottomTabs({ current, onNavigate }: Props) {
  const perfil = useAuth((s) => s.perfil);
  if (!perfil) return null;

  // Solo mostramos las 5 más importantes en el bottom (Inicio + 4 más)
  const all = routesForRole(perfil.rol);
  const priority = ['Dashboard', 'ProductosVenta', 'InsumosInternos', 'Solicitudes', 'Contabilidad', 'Alertas'];
  const tabs = priority.map((p) => all.find((r) => r.name === p)).filter(Boolean).slice(0, 5) as typeof all;

  return (
    <View
      style={{
        flexDirection: 'row',
        backgroundColor: colors.white,
        borderTopWidth: 1,
        borderTopColor: colors.ink[100],
        paddingTop: 6,
        paddingBottom: 10,
        paddingHorizontal: 6,
        // @ts-ignore web only
        backdropFilter: 'blur(8px)',
      }}
    >
      {tabs.map((route) => {
        const Icon = route.icon;
        const active = current === route.name;
        return (
          <Pressable
            key={route.name}
            onPress={() => onNavigate(route.name)}
            style={{
              flex: 1,
              alignItems: 'center',
              gap: 4,
              paddingVertical: 6,
            }}
          >
            <View
              style={{
                width: 44,
                height: 28,
                borderRadius: 14,
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: active ? colors.magenta[100] : 'transparent',
              }}
            >
              <Icon size={20} color={active ? colors.magenta[700] : colors.ink[400]} />
            </View>
            <Text
              style={{
                fontSize: 10,
                fontWeight: active ? typography.weights.bold : typography.weights.medium,
                color: active ? colors.magenta[700] : colors.ink[400],
                textAlign: 'center',
              }}
              numberOfLines={1}
            >
              {route.label.split(' ')[0]}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}
